import { render, staticRenderFns } from "./AppTape.vue?vue&type=template&id=109eac1f&"
import script from "./AppTape.vue?vue&type=script&lang=ts&"
export * from "./AppTape.vue?vue&type=script&lang=ts&"
import style0 from "./AppTape.vue?vue&type=style&index=0&id=109eac1f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports